// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2CMmg","title":"ClientCherryInfo_title__ctGWL","itemText":"ClientCherryInfo_itemText__Kbspn"};